class RmaFloatingCard extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'rma-floating-card-dismissed';
  }

  connectedCallback() {
    if (sessionStorage.getItem(this.storageKey) === 'true') return;

    this.hidden = false;

    const closeButton = this.querySelector('[data-rma-floating-card-close]');
    closeButton.addEventListener('click', () => this.dismiss());
  }

  dismiss() {
    this.hidden = true;
    sessionStorage.setItem(this.storageKey, 'true');
  }
}

customElements.define('rma-floating-card', RmaFloatingCard);
